export const environment = {
  production: false,
  apiUrl: 'https://api-dev.hero-app.io/api/v1/secure',
  clientId: 'uxo-mobile-app-client',
  keycloakUrl: 'https://keycloak-dev.hero-app.io/realms/uxo-mobile-app',
  mapboxAccessToken:
    'pk.eyJ1IjoiYnRyYW5zdWUiLCJhIjoiY2pxcTE3Z283MDdrcDN4bHB0MHBhc3NuOSJ9._S6TNeb-cFhdEcH0AUnaig',
  userPoolId: 'us-east-1_h7p0Fcwfp',
  userPoolClientId: '1aet4so7gfr4031uqovmuuj5f9',
  // Federated S3 access for report images (Cognito Identity Pool -> S3, no pre-signed URLs).
  awsRegion: 'us-east-1',
  identityPoolId: 'us-east-1:218ab099-acb6-44a8-8bbe-2ec79702974d',
  s3Bucket: 'io.hero-app.dev',
};
